<template>
    <mu-container fluid class="mt-5 border rounded bg-white">

        <div class="mt-1 mb-1" v-if="$validator.isObject(shopping)">
            <p class="font-condesed font__size-25 brand__centered global__blue">
                DETALLE DE VENTA
            </p>
            <hr>
            <div class="row">
                <div class="col-6">
                    <span class="font-condesed d-flex justify-content-end">
                        TOTAL
                    </span>
                </div>
                <div class="col-6 border-left">
                    <span class="font-condesed d-flex justify-content-start">
                        {{  total | currencyAmount }}
                    </span>
                </div>
                <hr>
            </div>
            <div class="row">
                <div class="col-6">
                    <span class="font-condesed d-flex justify-content-end">
                        TASA
                    </span>
                </div>
                <div class="col-6 border-left">
                    <span class="font-condesed d-flex justify-content-start">
                        {{  tasa | currencyAmount }}
                    </span>
                </div>
                <hr>
            </div>
            <div class="row">
                <div class="col-6 justify-content-end text-right">
                    <span class="font-condesed">
                        TOTAL GENERAL
                    </span>
                </div>
                <div class="col-6 border-left">
                    <span class="font-condesed d-flex justify-content-start">
                        {{  totalGeneral | currencyAmount }}
                    </span>
                </div>
                <hr>
            </div>
            <hr>
        </div>

        <template v-if="!disableTours && Object.keys(shopping).length > 0">

            <div class="card mb-2">
                <div class="d-flex">
                    <div class="ml-4 mr-3 mt-3">
                        <i class='bx bxs-trash bx__color close brand__item-tour__icon' @click="deleteItem"></i>
                    </div>
                    <div class="p-1" style="width: 140px;">
                        <span class="brand__item-tour">
                            {{ shopping.name }} 
                        </span>
                        <br>
                        <small>
                            Fecha: {{ $datetime.dateFormater(shopping.form.date, 'yyyy-mm-dd') }}
                        </small>
                    </div>
                </div>
                
                <div class="p-3">
                    <div class="row">
                        <div class="col-12">
                            <mu-date-picker 
                                class="mu-picker__detail"
                                :date="formatDate(shopping.form.date)" 
                                no-display
                                v-model="shopping.form.date"
                                :date-time-format="enDateFormat"
                                @change="changeDate"
                                :min-date="new Date()" />
                        </div>
                        <div class="col-12" v-if="shopping.timeslot !== null">
                            <mu-select 
                                class="mu-input__label"
                                label="Hora"
                                v-model="shopping.form.hour" 
                                full-width 
                                @change="selectHour">
                                <mu-option v-for="(item, index_hour) in shopping.timeslot.hours" :key="index_hour" :label="item.value" :value="item.select"></mu-option>
                            </mu-select>
                            <small style="color: red;" v-if="shopping.form.hour === null">
                                Selecciona un horario
                            </small>
                        </div>
                        <div class="col-12" v-else>
                            <small style="color: red;" v-if="shopping.form.hour === null">
                                No hay horrios diponibles
                            </small>
                        </div>
                        <div class="col-12" >
                            <span class="font-condesed font__size-12 text-center">
                                <b>
                                    {{ shopping.sale_child.label }}
                                </b>
                            </span>
                        </div>
                        <div class="col-12" v-if="shopping.timeslot !== null">
                            <div class="row">
                                <div class="col-6" v-for="(item, index_rate) of shopping.timeslot.rates" :key="index_rate">

                                    <span class="brand__item-price font__size-12">
                                        {{ item.price | currencyAmount }} MXN
                                    </span>

                                    <mu-select 
                                        :label="item.label" 
                                        v-model="shopping.form.rate[item.name.toLowerCase()]" 
                                        full-width 
                                        :disabled="shopping.form.hour === null || (item.name.toLowerCase() === 'child' && !shopping.sale_child.label)"
                                        @change="selectRate">
                                        <mu-option v-for="(rate, index) in 10" :key="index" :label="`${rate}`" :value="rate"></mu-option>
                                    </mu-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row">
                        <div class="col-6">
                            <span class="font-condesed font__size-12 text-left">
                                DESCUENTOS
                            </span>
                        </div>
                        <div class="col-6">
                            <span class="font-condesed font__size-12 text-right">
                                {{ shopping.average }} %
                            </span>
                        </div>
                    </div>
                    <hr>
                    <div class="row">
                        <div class="col-6">
                            <span class="font-condesed font__size-12 text-left">
                                TOTAL
                            </span>
                        </div>
                        <div class="col-6">
                            <span class="font-condesed font__size-12 text-right">
                                {{ key.form.summary.total * Number(`0.${key.form.summary.tax}`) | currencyAmount }}
                            </span>
                        </div>
                    </div> -->
                </div>
            </div>
        </template>

        <p class="mt-2 mb-1 brand__title brand__title__25 brand__centered" v-if="!disableTours">
            <template v-if="$validator.isObject(shopping)">
                <span class="font-condesed font__size-14 brand__title__blue">
                    Configura tu reservación
                </span>
            </template>
            <template v-else>
                <span class="font-condesed font__size-14 global__blue">
                    Selecciona el tour de tu preferencia
                </span>
            </template>
        </p>

        <div class="row" v-if="$validator.isObject(shopping)">
            
            <template v-if="$route.name === 'tours-search'">
                <div class="col-12 d-flex justify-content-center">
                    <vs-button 
                        square 
                        warn
                        block
                        color="#369070"
                        @click="goContinue('tours-payment')"
                    >
                       Siguiente (Proceder al pago)<i class='bx bx-cart ml-3'></i>
                    </vs-button>
                </div>
                <div class="col-12 d-flex justify-content-center">
                    <vs-button 
                        square
                        warn
                        block
                        @click="goCancel"
                    >
                        Cancelar
                    </vs-button>
                </div>
            </template>
            <template v-else-if="$route.name === 'tours-payment'">
                <div class="col-12 d-flex justify-content-center">
                    <vs-button 
                        square 
                        warn
                        block
                        color="#369070"
                        @click="goContinue('tours-ticket')"
                    >
                       Siguiente (Generar boleto)<i class='bx bx-cart ml-3'></i>
                    </vs-button>
                </div>
                <div class="col-12 d-flex justify-content-center">
                    <vs-button 
                        square
                        warn
                        block
                        @click="goCancel"
                    >
                        Cancelar
                    </vs-button>
                </div>
            </template>
        </div>

        
    </mu-container>
</template>

<script>

import _GlobalHelper from '@/store/helpers/global'
import _ToursShopping from '@/store/helpers/tours/shopping'
import _ToursCheck from '@/store/helpers/tours/check'
import _ToursCatalog from '@/store/helpers/tours/catalog'

import _ from 'lodash'

import { mapMutations, mapGetters, mapActions } from 'vuex'

const dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
const dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep','Oct', 'Nov', 'Dec'];
const monthLongList = ['January', 'February', 'March', 'April', 'May', 'June','July', 'August', 'September', 'October', 'November', 'December'];

const enDateFormat = {
    formatDisplay (date) {
        return `${dayList[date.getDay()]}, ${monthList[date.getMonth()]} ${date.getDate()}`;
    },
    formatMonth (date) {
        return `${monthLongList[date.getMonth()]} ${date.getFullYear()}`;
    },
    getWeekDayArray (firstDayOfWeek) {
        let beforeArray = [];
        let afterArray = [];
        for (let i = 0; i < dayAbbreviation.length; i++) {
            if (i < firstDayOfWeek) {
                afterArray.push(dayAbbreviation[i]);
            } else {
                beforeArray.push(dayAbbreviation[i]);
            }
        }
        return beforeArray.concat(afterArray);
    },
    getMonthList () {
        return monthList
    }
}

export default {
    props: {
        isDetail: {
            type: Boolean,
            default: () => { return false }
        }
    },
    
    computed: {
        ...mapGetters({
            shopping: _ToursShopping.getters.shopping,
            session: _ToursCheck.getters.session
        }),

        loading: {
            set(data) {
                this.set_loading(data)
            },
            get() {
                return this.loading
            }
        },


        total() {

            let total = this.shopping.form !== undefined ? this.shopping.form.summary.total : 0.00
            return total
        },

        tasa() {

            let total = this.shopping.form !== undefined ? this.shopping.form.summary.total * this.$config.adventures.tax : 0.00
            total = total > 0 ? this.$fixed(Math.abs(Number(total - this.shopping.form.summary.total ))) : 0.00
            return total
        },

        totalGeneral() {

            let total = this.shopping.form !== undefined ? this.shopping.form.summary.total * this.$config.adventures.tax : 0.00
            return total
        },

        disableTours() {
            return ['tours-payment', 'tours-ticket'].includes(this.$route.name)
        },

    },

    data() {
        return {
            date: new Date(),
            enDateFormat,
            hour: null,
            rates: [],
            attemp: 0
        }
    },
    methods: {

        ...mapActions({
            keep_session: _ToursCheck.actions.keep_session,
            keep_shopping: _ToursShopping.actions.keep_shopping,
            dates: _ToursCatalog.actions.dates,
            timeslots: _ToursCatalog.actions.timeslots
        }),

        ...mapMutations({
            setShopping: _ToursShopping.mutations.setShopping,
            setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
            set_loading: _GlobalHelper.mutations.loading,
            setContact: _ToursShopping.mutations.setContact,
            setPayment: _ToursShopping.mutations.setPayment
        }),

        async changeDate(event) {

            this.loading = {
                show: true,
                message: `
                    <mu-container>
                        <h2>${this.$i18n.t(`loading.search_adventures`)}</h2>
                        <mu-row>
                            <mu-col>
                                <h5>
                                    VALIDANDO DISPONIBILIBIDAD PARA LA FECHA ${this.$datetime.dateFormaterer(new Date(event), 'yyyy-mm-dd')}.
                                </h5>
                            </mu-col>
                        </mu-row>
                    </mu-container>`
            }

            const avaibility = await this.getAvaibility(this.shopping.id, event)

            // if(avaibility == null) {
            //     this.setAlertSimple({
            //         show: true,
            //         title: 'No es posible seleccionar el tour',
            //         message: 'No hay disponibilidad para la fecha seleccionada'
            //     })

            //     this.loading = { show: false }
            //     return
            // }

            const timeslot = await this.getTimeslots(this.shopping.id, this.shopping, event)

            // if(timeslot == null) {
            //     this.setAlertSimple({
            //         show: true,
            //         title: 'No es posible seleccionar el tour',
            //         message: 'El Tour seleccionado no cuenta con horas y tarifas diponibles'
            //     })
            //     this.loading = { show: false }
            //     return null
            // }

 
            let update = this.shopping      
            update.form.date = event
            update.form.hour = null
            update.form.rate = {
                adult: 0,
                child: 0
            }
            update.form.summary = {
                total: 0.00,
                tax: 1.08
            }
            update.avaibility = avaibility
            update.timeslot = timeslot

            this.setShopping({
                shopping: Object.assign(this.shopping, update)
            })

            this.loading = { show: false }
        },

        async getAvaibility(id, date) {

            return new Promise(async (resolve) => {
                await this.dates({
                    tour: id,
                    start_date: this.$datetime.dateFormaterer(date, 'yyyy-mm-dd'),
                    end_date: this.$datetime.dateFormaterer(date, 'yyyy-mm-dd')
                }).then(({success, data, error}) => {

                    if(!success) {
                        resolve(null)
                        return
                    }

                    if(data.dates.length === 0) {
                        resolve(null)
                        return
                    }

                    const { max_tickets } = _.find(data.dates, (key) => key.date === this.$datetime.dateFormaterer(date, 'yyyy-mm-dd'))
                    
                    resolve(max_tickets)

                })  
            })

        },

        async getTimeslots(id, value, date) {
            return new Promise(async (resolve) => {

                console.log({
                    tour: id,
                    start_date: this.$datetime.dateFormaterer(date, 'yyyy-mm-dd'),
                    end_date: this.$datetime.dateFormaterer(date, 'yyyy-mm-dd')  
                })

                await this.timeslots({
                    tour: id,
                    start_date: this.$datetime.dateFormaterer(date, 'yyyy-mm-dd'),
                    end_date: this.$datetime.dateFormaterer(date, 'yyyy-mm-dd')  
                }).then(({success, data, error}) => {
                    
                    if(!success) {

                        resolve(null)
                        return
                    }

                    console.log(data)

                    const result = _.find(data.available, (key) => key.date === this.$datetime.dateFormaterer(date, 'yyyy-mm-dd'))

                    console.log(result)
                    
                    for(let key in result.rates) {

                        if(result.rates[key].name === 'Adult') {
                            result.rates[key].label = 'Adulto'
                            result.rates[key].price = value.pricing.adult
                            result.rates[key].price_no_average = value.pricing.adult_no_average 
                        }

                        if(result.rates[key].name === 'Child') {
                            result.rates[key].label = 'Niños'
                            result.rates[key].price = value.pricing.child
                            result.rates[key].price_no_average = value.pricing.child_no_average 
                        }
                    }

                    resolve({
                        rates: result.rates,
                        hours: data.hours
                    })
                })
            })
        },

        openCollapse(id, index) {

            let active = this.shopping[index].expand = !this.shopping[index].expand

            let update = this.shopping
            update[index].expand = active

            this.setShopping({
                shopping: Object.assign(this.shopping, update),
                update: true
            })

            this.$root.$emit('bv::toggle::collapse', id)
        },

        deleteItem(index) {
 
            this.setShopping({
                shopping: null
            })
        },

        formatDate(value) {
            return new Date(value)
        },

        selectHour(event) {  

            this.rates = this.shopping.timeslot.rates
            this.shopping.hour = this.shopping.form.hour = this.shopping.timeslot.hours[event].value

        },

        selectRate(event) {
        

            let accept_adult = false
            let message = []
            for(let i in this.shopping.timeslot.rates) {
                const key = this.shopping.timeslot.rates[i]

                console.log(key)

                if(this.shopping.form.rate.adult > key.max_tickets && key.name === 'Adult') {
                    accept_adult = true
                    message.push('No hay cupos disponibles para adultos en este tour')
                }

                if(this.shopping.form.rate.child > key.max_tickets && key.label === 'Child') {
                    accept_adult = true
                    message.push('No hay cupos disponibles para menos en este tour')
                }
            }
            
            if(accept_adult) {
                this.setAlertSimple({
                    show: true,
                    title: 'Cupos limitados en el tour',
                    message: message
                })
                return
            }

            let total = 0

            if(this.shopping.form.rate.adult > 0) {
                total += this.shopping.form.rate.adult * this.shopping.pricing.adult
            }

            if(this.shopping.form.rate.child > 0) {
                total += this.shopping.form.rate.child * this.shopping.pricing.child
            }

            let update = this.shopping.form.summary.total = total

            this.setShopping({
                shopping: Object.assign(this.shopping, update)
            })

        },

        goCancel() {
            this.$router.push({
                name: 'home'
            })
        },

        goContinue(step) {

            console.log(step)

            switch(step) {
                case 'tours-checkout':
                    this.buyContinue()
                    break
                case 'tours-customer':
                    this.customerContinue()
                    break
                case 'tours-payment':
                    console.log(1)
                    this.paymentContinue()
                    break
                case 'tours-ticket':
                    this.attemp++
                    this.setPayment(this.attemp)
                    break
                default:
                    this.$router.push({
                        name: 'tours-search'
                    })
            }

        },

        async buyContinue() {

            return new Promise((resolve) => {

                let accept_adult = false
                let message = []
                for(let i in this.shopping.timeslot.rates) {
                    const key = this.shopping.timeslot.rates[i]

                    console.log(key)

                    if(this.shopping.form.rate.adult > key.max_tickets && key.name === 'Adult') {
                        accept_adult = true
                        message.push('No hay cupos disponibles para adultos en este tour')
                    }

                    if(this.shopping.form.rate.child > key.max_tickets && key.label === 'Child') {
                        accept_adult = true
                        message.push('No hay cupos disponibles para menos en este tour')
                    }
                }
                
                if(accept_adult) {
                    this.setAlertSimple({
                        show: true,
                        title: 'Cupos limitados en el tour',
                        message: message
                    })
                    return
                }

                this.loading = {
                    show: true,
                    message: `
                        <mu-container>
                            <h2>${this.$i18n.t(`loading.search_adventures`)}</h2>
                            <mu-row>
                                <mu-col>
                                    <h5>
                                        GUARDANDO TOURS, ESPERE...
                                    </h5>
                                </mu-col>
                            </mu-row>
                        </mu-container>`
                }

                message = []

                if(this.shopping.form.summary.total === 0) {
                    message.push(`En el tour ${this.shopping.name} no ha seleccionado los cupos correspondientes`) 
                }

                if(message.length > 0) {
                    this.loading = { show: false }
                    this.setAlertSimple({
                        show: true,
                        title: 'Información incompleta',
                        message: message
                    })
                    resolve({
                        success: false
                    })
                    return
                }

                this.keep_shopping({
                    body: {
                        shopping: this.shopping,
                        reservation_id: this.$route.query.id !== undefined ? this.$route.query.id : null,
                    }
                }).then(({ success, error, data }) => {
                    
                    if(!success) {
                        this.loading = { show: false }
                        this.setAlertSimple({
                            show: true,
                            title: 'Problemas al procesar el carrito',
                            message: 'No ha sido posible guardar el carrito de compras, intentelo de nuevo.'
                        })
                        resolve({
                            success: false
                        })
                        return
                    }

                    this.$storage.deleteKey('shopping')

                    this.loading = { show: false }

                    resolve({
                        success: true
                    })

                })
            })
        },

        customerContinue() {

            return new Promise((resolve) => {
                this.loading = {
                    show: true,
                    message: `
                        <mu-container>
                            <h2>${this.$i18n.t(`loading.search_adventures`)}</h2>
                            <mu-row>
                                <mu-col>
                                    <h5>
                                        REVISANDO TOURS, ESPERE...
                                    </h5>
                                </mu-col>
                            </mu-row>
                        </mu-container>`
                }

                let message = []

                let key = this.shopping

                if(key.form.summary.total === 0) {
                    message.push(`En el tour ${key.name} no ha seleccionado los cupos correspondientes`) 
                }

                if(message.length > 0) {
                    this.loading = { show: false }
                    this.setAlertSimple({
                        show: true,
                        title: 'Información incompleta',
                        message: message
                    })
                    resolve({
                        success: false
                    })
                    return
                }

                resolve({
                    success: true
                })
            })

        },

        async paymentContinue() {

            const buy = await this.buyContinue()

            if(!buy.success) {
                return
            }

            const keep_shooping = await this.customerContinue()

            if(!keep_shooping.success) {
                return
            }

            this.$storage.deleteKey('shopping')

            this.$router.push({
                name: 'tours-payment'
            })

        },

        ticket() {
            
        }
    },

    created() {

        console.log("session", this.session)
    }
}
</script>

<style lang="scss" >

    @media only screen and (max-width: 1170px) {
        .mu-select-input, .mu-select-icon {
            color: #000 !important;
        }
    }

    @media only screen and (max-width: 540px) {
        .mu-select-input, .mu-select-icon {
            color: #000 !important;
        }
    }

    .card {
        & {
            cursor: pointer;
        }
    }
    
    .bx {
        &__color {
            color: rgb(183, 28, 28) !important;
        }
    }

    // .mu-picker {
    //     width: 250px !important;
    // }

    .mu-day-button-bg {
        left: 0px !important;
    }

    .mu-input {

        &__label {
            .mu-input-label {
                font-size: 23px;
            }
        }
    }

    .mu-picker {

        &__detail {
            & {
                width: 220px !important;
                padding-bottom: 1px !important;
                
            }

            .mu-datepicker-monthday-row {
                height: 30px !important;
            }

            .mu-day-button-bg {
                left: -2px !important;
            }

            .mu-datepicker-monthday {
                height: 170px !important;
            }
        }

    }

    .mu-expansion-panel {
        & {
            border-radius: 6px !important;   
        }
    }

</style>